import React, { useState } from 'react';
import AdminCouponManager from './AdminCouponManager';
import PriceList from './PriceList';
import OrdersEmail from './OrdersEmail';
import AllOrders from './AllOrders';
import AllUsers from './AllUsers';
import CashBack from './CashBack';

const Admin = () => {
  // State to track selected tab
  const [activeTab, setActiveTab] = useState('coupon');

  // Function to render content based on the selected tab
  const renderTabContent = () => {
    switch (activeTab) {
      case 'coupon':
        return <AdminCouponManager />;
      case 'prices':
        return <PriceList />;
      case 'emails':
        return <OrdersEmail />;
      case 'orders':
        return <AllOrders />;
      case 'users':
        return <AllUsers />;
      case 'setcashback':
        return <CashBack />;
      default:
        return "";
    }
  };

  return (
    <div className="p-4">
      <h2 className="text-2xl font-bold mb-4">Admin Dashboard</h2>

      {/* Tab Navigation */}
      <div className="flex space-x-4 mb-4">
        <button
          onClick={() => setActiveTab('coupon')}
          className={`px-4 py-2 rounded ${activeTab === 'coupon' ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
        >
          Coupon
        </button>

        <button
          onClick={() => setActiveTab('users')}
          className={`px-4 py-2 rounded ${activeTab === 'users' ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
        >
          All Users
        </button>

        <button
          onClick={() => setActiveTab('emails')}
          className={`px-4 py-2 rounded ${activeTab === 'emails' ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
        >
          All Emails
        </button>

        <button
          onClick={() => setActiveTab('orders')}
          className={`px-4 py-2 rounded ${activeTab === 'orders' ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
        >
          All Orders
        </button>

        <button
          onClick={() => setActiveTab('prices')}
          className={`px-4 py-2 rounded ${activeTab === 'prices' ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
        >
          Prices
        </button>
        <button
          onClick={() => setActiveTab('setcashback')}
          className={`px-4 py-2 rounded ${activeTab === 'prices' ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
        >
          Set Cashback
        </button>
      </div>

      {/* Content Area */}
      <div className="border rounded-lg p-4">
        {renderTabContent()}
      </div>
    </div>
  );
};

export default Admin;
